export default "__VITE_ASSET__BgsclJK5__"